import KioskInventoryContainer from './kiosk-inventory-container';

export default KioskInventoryContainer;
